import SceneObject from "../../../lib/services/scene/sceneobject";
import ShaderService from "../../../lib/services/shader/shader_service";
import PapercraftStaticRenderPipeline from "../../../lib/services/render/pipelines/papercraft_static_renderpipeline";
import Camera from "../../../lib/services/scene/camera";
import ResourceService from "../../../lib/services/resource/resourceservice";
import BlobShadow from "../../../lib/services/scene/blob_shadow";
export const BoneColorCount = 7;

export default class Bone extends SceneObject {
  static_renderpipeline: PapercraftStaticRenderPipeline;
  color_index: number;
  shadow: BlobShadow;
  constructor(key: string, color_index: number = 0) {
    super(key);

    this.color_index = Math.max(0, Math.min(BoneColorCount - 1, color_index));

    const texture_name = `bone_color_${this.color_index}`;

    this.static_renderpipeline = new PapercraftStaticRenderPipeline(
      key,
      "papercraft_static",
      "bone",
      texture_name
    );
       this.shadow = new BlobShadow("bone_shadow", 0.8);
       this.add_child(this.shadow);
  }

  static random(key: string): Bone {
    const idx = Math.floor(Math.random() * BoneColorCount);
    return new Bone(key, idx);
  }

  async build(
    device: GPUDevice,
    format: GPUTextureFormat,
    shader_service: ShaderService,
    resource_service: ResourceService
  ): Promise<void> {
    await this.static_renderpipeline.build(device, format, shader_service, resource_service);
  }

  tick(_delta_time: number): void
  {
      this.shadow.update_shadow(this.transform.position[0],this.transform.position[1],this.transform.position[2]);
  }

  prepare(device: GPUDevice, camera: Camera): void {
    this.static_renderpipeline.prepare(device, camera, this.transform);
  }

  draw(pass: GPURenderPassEncoder): void {
    this.static_renderpipeline.draw(pass);
  }
}